/**
 * Time on Site Control Component
 * 
 * Controls display based on time spent on site
 * 
 * @package TopBuddy
 */

import { ToggleControl, __experimentalNumberControl as NumberControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import ProBadge from '../ProBadge';

const TimeOnSiteControl = ({ enabled, seconds, onEnabledChange, onSecondsChange }) => {
	const postSettingsData = window.topbuddyPostSettings || {};
	const isProActive = postSettingsData.isProActive || false;
	const upgradeUrl = postSettingsData.upgradeUrl || 'https://wptopbuddy.com/?utm_source=plugin&utm_medium=topbuddy-free-plugin&utm_campaign=topbuddy-free-plugin-admin';

	return (
		<div className="topbuddy-display-rules__field">
			<ToggleControl
				label={
					<>
						{__('Time on Site', 'topbuddy')}
						{!isProActive && <ProBadge upgradeUrl={upgradeUrl} />}
					</>
				}
				help={__('Show notification after visitor has been on site for specified time', 'topbuddy')}
				checked={enabled}
				onChange={onEnabledChange}
				disabled={!isProActive}
				__nextHasNoMarginBottom
			/>
			
			{enabled && isProActive && (
				<NumberControl
					value={seconds}
					onChange={onSecondsChange}
					min={1}
					label={__('Seconds on site', 'topbuddy')}
					help={__('Number of seconds the visitor must spend on the site before showing the notification', 'topbuddy')}
					style={{ marginTop: '8px' }}
					__next40pxDefaultSize
				/>
			)}
		</div>
	);
};

export default TimeOnSiteControl;
